export var PRD_CONFIG = {
  getRecommendationServiceUrl: function getRecommendationServiceUrl(baseUrl) {
    return baseUrl ? "".concat(baseUrl, "/gateway/api/v1/recommendations") : '/gateway/api/v1/recommendations';
  },
  getUsersServiceUrl: function getUsersServiceUrl(productKey) {
    return productKey === 'jira' ? "/rest/api/3/user/bulk" : "/wiki/rest/api/user/bulk";
  },
  getGraphQLUrl: function getGraphQLUrl(baseUrl) {
    return baseUrl ? "".concat(baseUrl, "/gateway/api/graphql") : "/gateway/api/graphql";
  },
  getTeamsUrl: function getTeamsUrl(baseUrl) {
    return baseUrl ? "/".concat(baseUrl, "/gateway/api/v3/teams") : "/gateway/api/v3/teams";
  }
};